/**
 * Cities API
 * 城市相关 API 接口（公开路由，无需认证）
 */
import client from './client';

export interface CityFromAPI {
  id: string;
  name: string;
  nameZh: string;
  nameEn: string;
  countryCode: string;
  image: string;
  isRemoteOnly: boolean;
  jobCount: number;
  country?: {
    code: string;
    nameZh: string;
    nameEn: string;
  } | null;
}

export interface CityWithDetails extends CityFromAPI {
  jobs?: Array<{
    id: string;
    title: string;
    department: string;
    type: string;
    workStyle: string;
  }>;
}

/**
 * 获取所有城市（含动态 jobCount）
 */
export async function getCities(countryCode?: string): Promise<CityFromAPI[]> {
  const params = countryCode ? { countryCode } : {};
  return client.get('/cities', { params });
}

/**
 * 获取单个城市详情
 */
export async function getCity(id: string): Promise<CityWithDetails> {
  return client.get(`/cities/${id}`);
}

/**
 * 获取城市职位数映射表
 * 返回 { cityId: jobCount } 格式
 */
export async function getCityJobCounts(): Promise<Record<string, number>> {
  const cities = await getCities();
  const counts: Record<string, number> = {};
  cities.forEach(city => {
    counts[city.id] = city.jobCount;
  });
  return counts;
}
